import { Fragment } from 'react';

interface PostSuccessProps {
    locationName?: string,
    lat: number,
    lng: number,
}

export const PostSuccess = ({ locationName, lat, lng }: PostSuccessProps) => {
    const locationText = locationName ? `in ${locationName}` : 'near you';

    return (
            <Fragment>
                <div className="iheart submitted">
                    <div className="header">
                        <h1>It’s our turn to thank you!</h1>
                        <p className="subheader">
                            Thank you for nominating a teacher! We’ll notify you if they’ve been selected to win $5,000 in classroom supplies.
                        </p>
                    </div>

                        <div className="give-while-you-wait">
                            <p>In the meantime…still eager to give back?</p>
                            <p>You can support another teacher in your own community in less than 5 minutes!</p>
                            <a href={`${baseFrontURL}donors/map.html?centerLat=${lat}&centerLng=${lng}`} className="button-primary">Find a classroom to support</a>
                        </div>

                        <div className="get-help">
                            Have any questions about DonorsChoose? <a href="https://help.donorschoose.org" className="button-secondary">Visit our help center</a>
                        </div>
                </div>
            </Fragment>
    );
}
